import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getCommonInfo, putPAEAA014UpdateMatching } from '../../services/Api';

const initialState = {
    savedPAEAA014Conditions: [],
    savedPAEAA014History: [],
};

export const fetchInitialConditions = createAsyncThunk(
    'PAEAA014/fetchInitialConditions',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await getCommonInfo();
            if (data.matchSubway) {
                const parsed = JSON.parse(data.matchSubway);
                return Array.isArray(parsed) ? parsed : [parsed];
            }
            return [];
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

export const saveMatchingConditions = createAsyncThunk(
    'PAEAA014/saveMatchingConditions',
    async (memberSeq, { getState, rejectWithValue }) => {
        try {
            const savedPAEAA014Conditions = getState().PAEAA014.savedPAEAA014Conditions;
            const matchingData = JSON.stringify(savedPAEAA014Conditions);
            const response = await putPAEAA014UpdateMatching({ seq: memberSeq, matching: matchingData });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

const PAEAA014Slice = createSlice({
    name: 'PAEAA014Reducer',
    initialState,
    reducers: {
        saveFilterPAEAA014Conditions: (state, action) => {
            const newCondition = {
                checkedStoreValues: action.payload.checkedValues,
                checkedLikeRightStoreValues: action.payload.checkedLikeRightValues,
                startStoreDate: action.payload.startDate,
                endStoreDate: action.payload.endDate,
                savedStoreDate: action.payload.savedDate,
                checkedStoreLabels: action.payload.checkedLabels,
                applyMethodStore: action.payload.applyMethod,
                subwayPostStore: action.payload.subwayPost,
                subwayNumStore: action.payload.subwayNum,
            };

            state.savedPAEAA014Conditions.push(newCondition);

            if (state.savedPAEAA014Conditions.length > 5) {
                state.savedPAEAA014Conditions.shift();
            }
        },

        deleteFilterPAEAA014Conditions: (state, action) => {
            const index = action.payload;
            if (index >= 0 && index < state.savedPAEAA014Conditions.length) {
                state.savedPAEAA014Conditions.splice(index, 1);
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchInitialConditions.fulfilled, (state, action) => {
            state.savedPAEAA014Conditions = action.payload;
        });
        builder.addCase(saveMatchingConditions.fulfilled, (state, action) => {});
    },
});

export const { saveFilterPAEAA014Conditions, deleteFilterPAEAA014Conditions } = PAEAA014Slice.actions;
export default PAEAA014Slice.reducer;
